<template lang='pug' src='./custom-office-team.pug'></template>

<script>

export default {
  props: ['props'],
  data () {
    return {
      titleActive: false,
      activeTile: false
    }
  },
  methods: {
    tileActive (i) {
      this.activeTile = i
    },
    tileNotActive () {
      this.activeTile = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-office-team.vue?aeba221e